import { pxToRem } from '@mos-cat/ds-theme';
import { WHCM } from '../../constants';

export const customStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  "input[type='search']&": {
    borderRadius: 'fieldBorderRadius',
  },
  'select&': {
    minHeight: pxToRem(48),
    mozAppearance: 'none',
    webkitAppearance: 'none',
    appearance: 'none',

    pr: '2em',
    backgroundImage: `url('data:image/svg+xml, %3Csvg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M6.32778 8.225C6.02405 7.92502 5.53159 7.925 5.22783 8.22495C4.92408 8.5249 4.92405 9.01124 5.22778 9.31123L11.2973 15.306C11.6868 15.6906 12.3132 15.6906 12.7027 15.3059L18.7722 9.31123C19.0759 9.01124 19.0759 8.5249 18.7722 8.22495C18.4684 7.925 17.9759 7.92502 17.6722 8.225L12 13.8273L6.32778 8.225Z" fill="%230E0E0F"/%3E%3C/svg%3E')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '1.5rem auto',
    backgroundPosition: 'center right 0.6875em',

    "&[aria-disabled='true']": {
      backgroundImage: `url('data:image/svg+xml, %3Csvg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M6.32778 8.225C6.02405 7.92502 5.53159 7.925 5.22783 8.22495C4.92408 8.5249 4.92405 9.01124 5.22778 9.31123L11.2973 15.306C11.6868 15.6906 12.3132 15.6906 12.7027 15.3059L18.7722 9.31123C19.0759 9.01124 19.0759 8.5249 18.7722 8.22495C18.4684 7.925 17.9759 7.92502 17.6722 8.225L12 13.8273L6.32778 8.225Z" fill="%23696C71"/%3E%3C/svg%3E')`,
      borderColor: 'fieldDisabledBorderColor',
      backgroundColor: 'fieldDisabledBgColor',
      color: 'fieldDisabledTextColor',
      pointerEvents: 'none',
      opacity: 1,
    },
  },

  'textarea&': {
    overflow: 'auto',
  },

  '&:hover': {
    borderColor: 'fieldHoverBorderColor',
    backgroundColor: 'fieldHoverBgColor',
  },
  '&::placeholder': {
    color: 'fieldPlaceholderColor',
    opacity: 1,
  },
  '&:-ms-input-placeholder': {
    color: 'fieldPlaceholderColor',
    opacity: 1,
  },
  '&:-moz-placeholder': {
    color: 'fieldPlaceholderColor',
    opacity: 1,
  },
  '&::-webkit-input-placeholder': {
    color: 'fieldPlaceholderColor',
    opacity: 1,
  },

  '&:focus': {
    borderColor: 'fieldFocusBorderColor',
    backgroundColor: 'fieldBgColor',
    boxShadow: 'focus',
  },
  '&:hover:focus': {
    borderColor: 'fieldFocusBorderColor',
    backgroundColor: 'fieldBgColor',
  },
  "&[aria-disabled='true']": {
    borderColor: 'fieldDisabledBorderColor',
    backgroundColor: 'fieldDisabledBgColor',
    color: 'fieldDisabledTextColor',
    pointerEvents: 'none',
  },

  "&[aria-disabled='true']:-ms-input-placeholder": {
    color: 'fieldDisabledTextColor',
    opacity: 1,
  },
  "&[aria-disabled='true']:-moz-placeholder": {
    color: 'fieldDisabledTextColor',
    opacity: 1,
  },
  "&[aria-disabled='true']::-webkit-input-placeholder": {
    color: 'fieldDisabledTextColor',
    opacity: 1,
  },

  [WHCM]: {
    '&::placeholder': {
      color: 'InactiveCaption',
    },
    '&:-ms-input-placeholder': {
      color: 'InactiveCaption',
    },
    '&:-moz-placeholder': {
      color: 'InactiveCaption',
    },
    '&::-webkit-input-placeholder': {
      color: 'InactiveCaption',
    },
    '&:focus': {
      outline: '4px solid auto',
    },
    "&[aria-disabled='true']": {
      color: 'ButtonShadow',
      backgroundColor: 'ButtonHighlight',
    },
    'select&': {
      backgroundImage: 'none',
      mozAppearance: 'auto',
      webkitAppearance: 'auto',
      appearance: 'auto',

      "&[aria-disabled='true']": {
        backgroundImage: 'none',
      },
    },
  },
};
